import Svg from '../generated/Like';
import { Icon, type IconProps } from './Icon';

export const LikeIcon = (props: IconProps) => <Icon component={Svg} name="like" {...props} />;
